import React from "react";
import { Subscribe } from "unstated";
import { FormattedMessage } from "react-intl";
import Alert from "react-bootstrap/Alert";

import { myGlobals, myFormValidations, myUtilities } from "../../Utils";

import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";

class MyInput extends React.Component {
  constructor(props) {
    super(props);
    this.myref = React.createRef();
    this.state = {
      showAlert: false,
      showAlert1: false,
      val: "",
      invalidRoutingNumber: false,
    };
  }

  isEUR = () => {
    if (this.props.EUR) return "EUR";
    else return "";
  };

  handleChange = (event, data) => {
    let val = event.target.value;
    this.myref.current.setCustomValidity("");
    let blacklisted = new RegExp(
      myFormValidations.getBlacklisted(this.props.name + this.isEUR())
    );
    if (!blacklisted.test(event.target.value)) {
      if (this.props.isMandateField) {
        let achMandateFields = data.state.achMandateFields;
        // console.log("achMandateField in state -> " + achMandateFields);
        console.log("value in achMandateField -> " + val);
        if (val.length > 0 && null != achMandateFields) {
          achMandateFields[this.props.name] = val;
          data.setACHMandateFields(achMandateFields);
        } else if (val.length > 0 && null == achMandateFields) {
          achMandateFields = {};
          achMandateFields[this.props.name] = val;
          data.setACHMandateFields(achMandateFields);
        }
      } else {
        data.populateInputData(this.props.name, event.target.value);
      }
      this.setState({
        val: val,
      });
    }
  };

  setPaymentData = (paymentData) => {
    this.paymentData = paymentData;
    if (!this.props.isMandateField &&
      this.state.val.length === 9 &&
      null !== this.paymentData.state[this.props.name] &&
      this.paymentData.state[this.props.name].localeCompare(
        this.myref.current.value
      ) !== 0
    )
      this.paymentData.populateInputData(
        this.props.name,
        this.myref.current.value
      );
  };

  alertContent = () => {
    if (this.state.showAlert) {
      return (
        <Alert className="my-alert-class" variant="danger">
          <p>
            {myUtilities.accountSpecificLanguage("Validation.bankaccountNoSixCharcters", "Account number must be minimum 6 digits")}
          </p>
        </Alert>
      );
    } else if (this.state.showAlert1) {
      return (
        <Alert className="my-alert-class" variant="danger">
          <p>
            {myUtilities.accountSpecificLanguage("Validation.bankaccountNoOnlyZero", "Account number can't have only zeros")}
          </p>
        </Alert>
      );
    } else if (this.state.invalidRoutingNumber) {
      if (this.paymentData.state.loadingPaymentStatus) {
        this.paymentData.setState({
          loadingPaymentStatus: false,
        });
      }
      return (
        <Alert className="my-alert-class" variant="danger">
          <p>
            {myUtilities.accountSpecificLanguage("payment.status.failed.invalidRoutingNumber", "Payment failed, Invalid Routing Number")}
          </p>
        </Alert>
      );
    }
  };

  getValidationMessage = () =>
    this.state.val === "" ||
    !this.state.val.match(
      myFormValidations.getFormValidation(this.props.name + this.isEUR())
    )
      ? myUtilities.accountSpecificLanguage(
          myFormValidations.getErrorMessage(this.props.name + this.isEUR()),
          "Please fill out this field.",
        )
      : "";

  onBlur = () => {
    if (this.myref.current.value.toString().length < 6) {
      this.setState({
        showAlert: true,
      });
      setTimeout(() => {
        this.setState({
          showAlert: false,
        });
      }, 3000);
    } else if (/^0*$/.test(this.myref.current.value.toString())) {
      this.setState({
        showAlert1: true,
      });
      setTimeout(() => {
        this.setState({
          showAlert1: false,
        });
      }, 3000);
    } else {
      this.paymentData.populateInputData(
        this.props.name,
        this.myref.current.value
      );
    }
  };
  onFocus = () => {
    // setTimeout(()=>{
    //   this.setState({
    //     showAlert: false,
    //     showAlert1: false
    //   })},3000);
  };

  setInvalidRoutingNumber = () => {
    this.setState({ invalidRoutingNumber: true });

    setTimeout(() => {
      this.setState({
        invalidRoutingNumber: false,
      });
    }, 3000);
  };

  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <div>
            {this.setPaymentData(data)}
            {this.alertContent()}
            {
              <input
                title={this.getValidationMessage()}
                ref={this.myref}
                onInvalid={() =>
                  this.myref.current.setCustomValidity(
                    (this.props.customValidationMessage != undefined &&
                    this.prop.customValidationMessage != null) ? 
                    myUtilities.accountSpecificLanguage(
                      this.props.customValidationMessageMLKey,
                      this.props.customValidationMessage
                    ) :
                    myUtilities.accountSpecificLanguage(
                      myFormValidations.getErrorMessage(
                        this.props.name + this.isEUR()
                      ),
                      "Please fill out this field."
                    )
                  )
                }
                // required = true by default
                // custom prop isRequiredField can be passed as props to override required
                required={
                  this.props.isRequiredField != undefined
                    ? this.props.isRequiredField
                    : true
                }
                name={this.props.name}
                className="payment-input-label"
                pattern={
                  this.props.customValidationRegex != undefined &&
                  this.props.customValidationRegex != null
                    ? this.props.customValidationRegex
                    : myFormValidations.getFormValidation(
                        this.props.name + this.isEUR()
                      )
                }
                type="text"
                value={this.state.val}
                onChange={(event) => {
                  this.handleChange(event, data);
                }}></input>
            }
          </div>
        )}
      </Subscribe>
	  );
  }

  componentDidMount() {
    if (this.props.name.localeCompare("bankAccNo") === 0 && !this.props.EUR) {
      this.myref.current.onblur = this.onBlur;
      this.myref.current.onfocus = this.onFocus;
    }
    myGlobals.setInvalidRoutingNumber = this.setInvalidRoutingNumber;
  }
}

export default MyInput;
